import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { useUIStore } from '@/store/uiStore';
import Sidebar from '@/components/layout/Sidebar';
import Header from '@/components/layout/Header';
import LoadingOverlay from '@/components/common/LoadingOverlay';
import NotificationContainer from '@/components/common/NotificationContainer';
import { requestFCMToken } from '@/config/firebaseNotification';
import axios from '../../node_modules/axios/index';
import { onNotification, setupMessageListener } from '@/config/firebaseNotification';
import { toast } from 'react-toastify';
import { AppLocalEnum, getLanguage } from '@/translate/text';
const MainLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoading: authLoading } = useAuthStore();
  const { isLoading: uiLoading, sidebarExpanded, currentTheme } = useUIStore();

  // Get language from localStorage
  const language = localStorage.getItem('language') || AppLocalEnum.EN;
  const isRTL = language === AppLocalEnum.AR;

  const getBgClass = () => {
    const path = location.pathname; // Define path so it's accessible

    switch (true) {
      case path === '/notification-center/new':
        return 'bg-gray-50 dark:bg-gray-900/20 rounded-lg shadow-sm transition-colors duration-300';

      case path === '/appointments':
      case /^\/appointments\/[a-zA-Z0-9-]+$/.test(path):
        return '';

      default:
        return 'bg-white dark:bg-gray-800 rounded-lg shadow-sm transition-colors duration-300';
    }
  };

  return (
    <>
      <div
        className={`
          min-h-screen
          flex
          flex-col
          ${currentTheme === 'dark' ? 'dark' : ''}
          bg-gray-50 
          dark:bg-gray-900 
          transition-colors 
          duration-200
        `}
      >
        <Header />

        <div className="flex flex-1 pt-16">
          <Sidebar />

          <main
            className={`
              flex-1
              transition-all
              duration-200
              ${isRTL ? (sidebarExpanded ? 'mr-64' : 'mr-20') : sidebarExpanded ? 'ml-64' : 'ml-20'}
              p-6
              relative
            `}
          >
            <div className={`${getBgClass()}`}>
              <div className="p-6">
                <Outlet />
              </div>
            </div>

            {uiLoading && <LoadingOverlay />}
          </main>
        </div>

        <NotificationContainer />
      </div>
    </>
  );
};

export default MainLayout;
